import { defineComponent as _defineComponent } from 'vue';
import { VSheet, VBtn, VIcon } from "vuetify/lib";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CodePreview',
    props: {
        code: null
    },
    setup(__props) {
        const props = __props;
        const highlight = (code) => {
            const escaped = code
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
            return escaped.replace(/&lt;(\/?)([\w-]+)(.*?)&gt;/g, (match, slash, tagName, attrs) => {
                const coloredAttrs = attrs.replace(/(\s+)([\w-:]+)(?:(=)(&quot;.*?&quot;|&#039;.*?&#039;))?/g, (m, space, name, eq, value) => {
                    let res = `${space}<span style="color: #d19a66">${name}</span>`;
                    if (eq && value)
                        res += `${eq}<span style="color: #98c379">${value}</span>`;
                    return res;
                });
                return `&lt;${slash}<span style="color: #e06c75">${tagName}</span>${coloredAttrs}&gt;`;
            });
        };
        const copyCode = () => {
            navigator.clipboard.writeText(props.code);
        };
        return { __sfc: true, props, highlight, copyCode, VSheet, VBtn, VIcon };
    }
});
